export default __webpack_public_path__ + "static/media/Financial-Results-Q1FY27.3f05da6b.pdf";